const actions = {
  CHECK_AUTHORIZATION: 'CHECK_AUTHORIZATION',
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGOUT: 'LOGOUT',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_ERROR: 'LOGIN_ERROR',
  checkAuthorization: () => ({ type: actions.CHECK_AUTHORIZATION }),
  login: (token) => {
    localStorage.setItem("isLoggedin", true);
    return {
      type: actions.LOGIN_SUCCESS,
      token
    }
  },
  logout: () => {
    localStorage.clear();
    return {
      type: actions.LOGOUT
    }
  },
  'IS_FIRST_TIME_LOGIN': 'IS_FIRST_TIME_LOGIN',
  'RESET_FIRST_TIME_LOGIN': 'RESET_FIRST_TIME_LOGIN',
  'SET_COGNITO_GROUPS': 'SET_COGNITO_GROUPS',
  'SET_PROVIDER': 'SET_PROVIDER',
  'SET_DB_ID': 'SET_DB_ID',
  'SET_S3_PHOTO': 'SET_S3_PHOTO',
  resetFirstTimeLogin: () => {
    return {
      type: actions.RESET_FIRST_TIME_LOGIN
    }
  }
};
export default actions;
